import React from 'react'

const FormInput = (props) => {
    const {label, error, onChange, onBlur, id, ...inputProps } = props;

  return (
    <div className='form-group'>
        <label className='form-label mb-2'>
            {label}
        </label>
        <input 
            className='form-control' 
            {...inputProps} 
            onChange={onChange} 
            onBlur={onBlur}
        />
        {error && (
            <div className="form-error">
                {error}
            </div>
        )}
    </div>
  )
}

export default FormInput